
import axios, { CancelTokenSource } from 'axios';
import { baseAxios } from '../../../services/interceptor';
;

export async function uploadFile(
  data: any,
  uploadUrl: string,
  onProgressUpdate: (progress: number) => void,
): Promise<any> {
  let updateProgressBarValue: number = 0;
  let upload: CancelTokenSource | null = null;

  try {
    upload = baseAxios.CancelToken.source();
    const file = new File([data], data.name, { type: data.type });
    const config = {
      cancelToken: upload.token,
      onUploadProgress: (progressEvent) => {
        const totalLength = progressEvent.lengthComputable
          ? progressEvent.total
          : progressEvent.target.getResponseHeader('content-length') ||
            progressEvent.target.getResponseHeader('x-decompressed-content-length');
        if (totalLength !== null) {
          updateProgressBarValue = Math.round((progressEvent.loaded * 100) / totalLength);
          onProgressUpdate(updateProgressBarValue);
        }
      },
      headers: {
        'Content-Type': file.type,
      },
    };
    const res = uploadUrl
      ? await baseAxios.put(uploadUrl, file, config)
      : await axios.post(`ingests/files`, data, config);
      
    if (uploadUrl) {
      return res;
    }
    return res.data;
  } catch (err) {
    if (!baseAxios.isCancel(err)) {
      // store.commit('alert/set', {
      //   message: clientUtils.errorResponseHandler(err, 'uploadFile'),
      //   type: 'error',
      //   position: 'n',
      // });
    }
    throw new Error();
  }
}
